import { FC } from 'react';

interface BadgeStatusProps {
  color: 'blue' | 'green' | 'red' | 'orange' | 'gray' | 'yellow' | 'purple' | 'indigo' | 'pink'
  // paleta de cobrança (tailwind.config.js): pagamento é verde, o tom diz qual
  | 'olive' | 'teal' | 'gold' | 'todo' | 'turquoise'
  // amarelo mais claro que o `yellow`, para selo de "esperando ação". Chave PRÓPRIA e não um
  // ajuste no `yellow`: aquele é usado por Operações (Suspenso), structuring e settlement, e
  // repintá-lo mudaria três telas que ninguém pediu para mudar
  | 'pending';
  text: string;
}

const BadgeStatus: FC<BadgeStatusProps> = ({ color, text }) => {
  const colorClasses: { [key: string]: string } = {
    blue: 'bg-blue-500 text-white',
    green: 'bg-green-500 text-white',
    red: 'bg-red-500 text-white',
    orange: 'bg-orange-500 text-white',
    gray: 'bg-gray-500 text-white',
    yellow: 'bg-yellow-500 text-black',
    pending: 'bg-yellow-400 text-black',   // esperando ação
    purple: 'bg-purple-500 text-white',
    indigo: 'bg-indigo-500 text-white',
    pink: 'bg-pink-500 text-white',
    olive: 'bg-pay-partial text-white',    // pagamento parcial
    teal: 'bg-pay-over text-white',        // recebimento a maior
    gold: 'bg-charge-open text-black',     // cobrança em aberto
    todo: 'bg-charge-todo text-white',     // falta faturar
    // texto preto como no gold: o darkturquoise é claro demais para carregar branco
    turquoise: 'bg-charge-over text-black',  // cobrança redundante (distinto do teal)
  };

  const badgeClass = `h-6 px-2 py-1 inline-flex items-center rounded-lg text-xs font-light ${colorClasses[color]}`;

  return (
    <span className={badgeClass}>
      {text}
    </span>
  );
};

export default BadgeStatus;
